import type { NavigateFunction, NavigateOptions } from 'react-router-dom'
import { __REACT_NATIVE__ } from '@disco/constants/environment'

class NavigationService {
  private static instance: NavigationService | null = null
  private navigate: NavigateFunction | null = null

  private constructor() {
    // Private constructor to prevent direct instantiation
  }

  static getInstance(): NavigationService {
    if (!NavigationService.instance) {
      NavigationService.instance = new NavigationService()
    }
    return NavigationService.instance
  }

  setNavigate(navigate: NavigateFunction): void {
    this.navigate = navigate
  }

  push(to: string | number, options?: NavigateOptions): void {
    if (__REACT_NATIVE__) {
      return
    }

    if (!this.navigate) {
      throw new Error('NavigationService: navigate function not initialized')
    }

    if (typeof to === 'number') {
      this.navigate(to)
    } else {
      this.navigate(to, options)
    }
  }

  replace(to: string | number, options?: NavigateOptions): void {
    if (__REACT_NATIVE__) {
      return
    }

    if (!this.navigate) {
      throw new Error('NavigationService: navigate function not initialized')
    }

    if (typeof to === 'number') {
      this.navigate(to)
    } else {
      this.navigate(to, { replace: true, ...options })
    }
  }

  goBack(): void {
    if (__REACT_NATIVE__) {
      return
    }

    if (!this.navigate) {
      throw new Error('NavigationService: navigate function not initialized')
    }

    this.navigate(-1)
  }

  goForward(): void {
    if (__REACT_NATIVE__) {
      return
    }

    if (!this.navigate) {
      throw new Error('NavigationService: navigate function not initialized')
    }

    this.navigate(1)
  }

  go(delta: number): void {
    if (__REACT_NATIVE__) {
      return
    }

    if (!this.navigate) {
      throw new Error('NavigationService: navigate function not initialized')
    }

    this.navigate(delta)
  }

  isInitialized(): boolean {
    return this.navigate !== null
  }
}

export default NavigationService.getInstance()
